<template>
    <!-- 标签页头部 -->
    <div class="tag-page-header">
        <!-- 名字 -->
        <div class="name">{{name}}</div>

        <!-- 毛玻璃遮罩层 -->
        <div class="pic-blur"></div>

    </div>
</template>

<script>
    import {GetSentences} from '@/request/poem';
    import { VueTyper } from 'vue-typer';
    export default {
        name: "Header",
       props:['name']
    }
</script>

<style lang="less">
    .tag-page-header{
        width: 100%;
        height: 350px;
        background-image: url("../../../../assets/poem-back.jpg");
        background-size: cover;
        background-position: center center;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        // 遮罩模糊
        .pic-blur{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top:0;
            background: inherit;
            filter: blur(1.8px);
        }
        /* 名字 */
        .name{
            z-index: 4;
            font-size: 43px;
            letter-spacing: 3px;
            color: white;
            font-weight: bold;
            font-family: 宋体;
            display: block;
            position: relative;
        }
    }
</style>